import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const homeRed = "#A40000";
const conveyrPurple = "#7b1fa2";

const Home: React.FC = () => {
    const [isExpandedTop, setIsExpandedTop] = useState(false);
    const [isHoveredTop, setIsHoveredTop] = useState(false);
    const [isHoveredBottom, setIsHoveredBottom] = useState(false);

    const topTextContent = (
        <>
            <h1 style={{ color: isHoveredTop || isExpandedTop ? "#fff" : homeRed, fontSize: "2rem", marginTop: 0, marginBottom: "1.2rem", transition: "color 0.35s ease" }}>Algebracorp OPC Private Limited</h1>
            <p>Algebracorp OPC Private Limited is an innovation-led Indian technology company focused on building AI-driven digital ecosystems that redefine how people connect, communicate, and create. At the core of Algebracorp's vision lies a commitment to National Digital Sovereignty, technological self-reliance, and the intelligent integration of artificial intelligence into everyday life.</p>
            <p>Our flagship product, <strong style={{ color: (isHoveredTop || isExpandedTop) ? "#fff" : conveyrPurple }}>Conveyr</strong>, is a next-generation AI-powered multi-sector platform that unifies communication, entertainment, health, fintech, and cloud services within one seamless ecosystem. Conveyr is designed to create a smart, secure, and self-sustaining digital environment, giving users complete control over their data and digital presence.</p>
            <p>Each module of Conveyr — including Chime, Blog, Chat, Music, Games, OTT (ReelBOX), Health, and Drive12 — is built as an independent AI-driven business vertical. Through deep learning and intelligent analytics, Conveyr personalizes content, curates experiences, identifies misinformation, and enhances user engagement — ensuring a safe, relevant, and immersive digital experience.</p>
            <p>At Algebracorp, we don't just create platforms — we design ecosystems. Our AI infrastructure powers not only Conveyr but also future-ready innovations across healthcare, finance, mobility, defense, and cloud computing.</p>
            <p>We are building the foundation of India's AI-powered digital future — a world where technology serves people, empowers nations, and drives meaningful progress.</p>
            <h2 style={{ color: isHoveredTop || isExpandedTop ? "#fff" : homeRed, marginTop: "1.5rem", fontSize: "1.15rem", transition: "color 0.35s ease" }}>Algebracorp – Empowering the Future through Intelligence.<br /><span style={{ color: (isHoveredTop || isExpandedTop) ? "#fff" : conveyrPurple }}>Conveyr</span> – India's AI-Powered Digital Ecosystem.</h2>
        </>
    );

    const middleTextContent = (
    <>
        <h2
            style={{
                color: isHoveredBottom ? "#fff" : homeRed,
                fontSize: "1.45rem",
                marginTop: 0,
                marginBottom: "1rem",
                transition: "color 0.35s ease",
            }}
        >
            URBANGRO – Modern Retail for Urban India
        </h2>

        <p
            style={{
                transition: "color 0.35s ease",
                color: isHoveredBottom ? "#fff" : "inherit",
            }}
        >
            URBANGRO is a modern, technology-enabled retail brand designed to redefine everyday shopping for urban India.
        </p>

        <p
            style={{
                transition: "color 0.35s ease",
                color: isHoveredBottom ? "#fff" : "inherit",
            }}
        >
            Built as part of the Conveyr ecosystem, URBANGRO combines large-format physical stores with digital commerce to deliver a seamless omni-channel experience.
        </p>

        <p
            style={{
                transition: "color 0.35s ease",
                color: isHoveredBottom ? "#fff" : "inherit",
            }}
        >
            Initially focused on daily needs and kitchen essentials, URBANGRO emphasizes convenience, efficiency, and customer-centric innovation while laying the foundation for scalable, multi-category retail expansion across India.
        </p>
    </>
);


    const bottomTextContent = (
        <>
            <h2 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, fontSize: "1.45rem", marginTop: 0, marginBottom: "1rem", transition: "color 0.35s ease" }}>Conveyr - National Digital Ecosystem & Digital Sovereignty</h2>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>Conveyr is India's first truly AI-powered digital ecosystem—a comprehensive platform that brings together communication, entertainment, finance, health, and cloud services into one unified experience.</p>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>Conveyr is not just a social media platform – it is India's first comprehensive digital ecosystem built to empower individuals, communities, businesses, and governments on one secure, homegrown platform. At its core, Conveyr brings together three pillars:</p>
            <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
                <li><strong>Chime</strong> – A space to express opinions and be heard.</li>
                <li><strong>Blog</strong> – A platform to share insights, ideas, and knowledge.</li>
                <li><strong>Chat</strong> – A secure way to connect and communicate.</li>
            </ul>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>Beyond this, Conveyr is building a powerful suite of services that go far beyond traditional social networks – including Conveyr Music, ReelBOX (OTT), Games, Ecommerce, Health, News, Live TV (Box), and Drive12 (cloud storage).</p>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>The platform is designed with a strong focus on digital sovereignty, user safety, and data privacy, ensuring Indians can enjoy entertainment, commerce, and secure communication without compromise.</p>
            <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem", listStyleType: "none" }}>
                <li>Ø  For users, Conveyr offers freedom of expression, trusted engagement, and diverse entertainment in one place.</li>
                <li>Ø  For businesses, it opens direct access to audiences, marketing, and commerce.</li>
                <li>Ø  For governments, it offers a secure and reliable channel to connect with citizens.</li>
            </ul>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>Conveyr is positioned to be profitable and scalable, leveraging its wide ecosystem to generate revenues across subscriptions, advertising, partnerships, e-commerce, and digital services.</p>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>With Conveyr, India moves a step closer to achieving national digital sovereignty – a self-reliant digital ecosystem where users feel safe, entertained, and empowered.</p>
            <p style={{ fontWeight: "bold", fontSize: "0.95rem", transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginTop: "1rem" }}>Conveyr is not just an app. It's an ecosystem.</p>
            <p style={{ fontWeight: "bold", fontSize: "0.88rem", transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>Conveyr – Where Intelligence Meets Innovation.</p>
            <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Algebracorp OPC Private Limited is a technology-first company building integrated digital products and platforms that address real-world commerce, media, and consumer needs. Bootstrapped and founded by Manish Srivastava, Algebracorp develops high-impact products that combine software, AI, and domain expertise to scale across markets. The company’s flagship product ecosystem is Conveyr, a multi-module digital platform designed to create a seamless bridge between digital services and physical commerce.
        </p>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Algebracorp is currently raising funds to accelerate Conveyr Phase II and scale its initial commercial modules, with URBANGRO — a retail-commerce initiative — as the first major physical-digital rollout.
        </p>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Vision & Mission
        </h3>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Vision: Build an integrated, AI-driven digital ecosystem that powers everyday commerce, media, and services for modern consumers — online and offline.
        </p>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Mission: Launch modular, revenue-generating products that independently solve specific customer problems while converging into a single, powerful Conveyr ecosystem that multiplies value via cross-sell, data, and distribution.
        </p>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Core Strengths
        </h3>

        <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Founder-led, domain expertise in finance, treasury, and operations (Founder: Manish Srivastava).</li>
            <li>In-house AI capabilities (DeepMatrix) for design, forecasting, personalization, content creation, and automation.</li>
            <li>Product-first mindset — Conveyr is already live on Android & iOS with core modules.</li>
            <li>Focus on building modules that are each fundable, revenue-generating, and integrable into a larger ecosystem.</li>
        </ul>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Conveyr — The Ecosystem (Overview)
        </h3>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Conveyr is a modular digital ecosystem built to combine social, commerce, media, and utility services into a unified experience. Each module is designed to be independently useful and monetizable, but all modules share user identity, payments, loyalty and data intelligence — amplifying customer lifetime value when used together.
        </p>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Conveyr’s core design principles:
        </p>

        <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Modularity: build and launch one module at a time (clear KPIs & GTM).</li>
            <li>Interoperability: shared user wallets, loyalty, identity & inventory where applicable.</li>
            <li>Data-first: centralized analytics & AI (DeepMatrix) to personalize and optimize across modules.</li>
            <li>Real-world distribution: physical nodes (e.g., URBANGRO stores) act as on-ground fulfillment and engagement hubs.</li>
        </ul>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Conveyr — Key Modules & What They Do
        </h3>

        <p style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit" }}>
            Below is a concise description of Conveyr’s major modules (existing and planned) and how they create an integrated stack:
        </p>

        <ol style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Conveyr Chime — Micro-posts & social expression module.</li>
            <li>Conveyr Blog — Long-form content & publisher module.</li>
            <li>Conveyr Chat — Secure messaging.</li>
            <li>Conveyr Commerce / E-commerce — Marketplace & storefronts.</li>
            <li>Conveyr Logistics — Fulfillment & last-mile.</li>
            <li>Conveyr Payments & Wallet — Unified payment rails.</li>
            <li>Conveyr Loyalty & Rewards — Single loyalty engine.</li>
            <li>Conveyr Data & Predictive AI (DeepMatrix) — Intelligence layer.</li>
            <li>Conveyr Music — Music streaming & creator tools.</li>
            <li>ReelBOX (OTT) — Short- and long-form video & OTT content.</li>
            <li>Games — Casual games & engagement hooks.</li>
            <li>Conveyr Health — Healthcare & pathology rollout (physical-first).</li>
            <li>Drive12 (Cloud / Storage) — Cloud storage and document services.</li>
            <li>Box (Live TV) — Live TV and streaming integration for content partners and advertisers.</li>
        </ol>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Technology Backbone & AI (DeepMatrix)
        </h3>

        <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Personalization (content & commerce)</li>
            <li>Predictive demand & stock forecasting for stores (critical for URBANGRO)</li>
            <li>Automated creative generation (images, copy, video) for marketing & product content</li>
            <li>Conversational interfaces and virtual assistants</li>
            <li>Forecasting & financial scenario simulation for the business</li>
        </ul>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            Business Model — How Algebracorp & Conveyr Make Money
        </h3>

        <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Transaction fees from marketplace sales and URBANGRO order fulfillment.</li>
            <li>Commissions and listing fees from merchants on Conveyr Commerce.</li>
            <li>Subscription & premium features.</li>
            <li>Advertising & sponsored content.</li>
            <li>Payment & wallet float / processing fees.</li>
            <li>Logistics & fulfillment fees.</li>
            <li>Private-label and higher-margin URBANGRO SKUs.</li>
            <li>B2B SaaS for retailers.</li>
        </ul>

        <h3 style={{ color: isHoveredBottom ? "#fff" : conveyrPurple, transition: "color 0.35s ease" }}>
            URBANGRO — What It Is & Why It’s the First Focus
        </h3>

        <ul style={{ transition: "color 0.35s ease", color: isHoveredBottom ? "#fff" : "inherit", marginLeft: "1.5rem" }}>
            <li>Flagship hypermarket format with future smaller formats.</li>
            <li>Daily essentials-focused Phase 1 for predictable unit economics.</li>
            <li>Deep integration with Conveyr Commerce, Logistics, Wallet, and AI layers.</li>
            <li>Each store acts as fulfillment center, acquisition point, and loyalty engine.</li>
            <li>Essentials-led model enables fast, fundable, scalable revenue.</li>
        </ul>
        </>
    );

    return (
        <div style={{ position: "relative", width: "100%", minHeight: "100vh", background: "#fff" }}>
            {isExpandedTop && (
                <div onClick={() => setIsExpandedTop(false)} style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(5px)" }}>
                    <div onClick={(e) => e.stopPropagation()} style={{ width: "85vw", maxWidth: "1200px", height: "85vh", color: "#fff", fontWeight: 500, fontSize: "0.95rem", lineHeight: 1.7, borderRadius: "18px", padding: "3rem", background: homeRed, boxShadow: "0 8px 40px rgba(0, 0, 0, 0.3)", overflowY: "auto", position: "relative" }}>
                        <button onClick={() => setIsExpandedTop(false)} style={{ position: "absolute", top: "1.5rem", right: "1.5rem", background: "#fff", color: homeRed, border: "none", borderRadius: "50%", width: "36px", height: "36px", cursor: "pointer", fontSize: "1.3rem", fontWeight: "bold" }}>×</button>
                        {topTextContent}
                    </div>
                </div>
            )}

            <div style={{ position: "relative", zIndex: 1, paddingBottom: "2rem" }}>
                <div style={{ minHeight: "33vh", display: "flex", alignItems: "stretch", justifyContent: "space-between", padding: "1.5rem 2rem", gap: "2rem", marginBottom: "0.5rem" }}>
                    <div style={{ position: "relative", flex: "1 1 58%" }}>
                          <div
                            onMouseEnter={() => setIsHoveredTop(true)}
                            onMouseLeave={() => setIsHoveredTop(false)}
                            style={{
                                background: isHoveredTop ? homeRed : "rgba(255, 255, 255, 0.92)",
                                color: isHoveredTop ? "#fff" : homeRed,
                                padding: isHoveredTop ? "2.3rem 2.3rem" : "1.8rem 2rem",
                                borderRadius: "18px",
                                cursor: "pointer",
                                boxShadow: "0 4px 24px rgba(0, 0, 0, 0.15)",
                                fontWeight: 500,
                                fontSize: "0.78rem",
                                lineHeight: 1.58,
                                transition: "all 0.45s ease",
                                
                                /* ⭐ HOVER EXPAND BEHAVIOUR */
                                maxHeight: isHoveredTop ? "780px" : "32vh",
                                overflow: "hidden"
                            }}
                        >
                            {topTextContent}
                        </div>
                        
                    </div>
                    <div style={{ flex: "0 0 36%", display: "flex", flexDirection: "column", gap: "1rem", alignItems: "center", justifyContent: "flex-start" }}>
                        <img src={require('../assets/AI7.jpg')} alt="AI 7" style={{ width: "100%", maxWidth: "400px", height: "auto", borderRadius: "14px", boxShadow: "0 4px 16px rgba(164, 0, 0, 0.15)" }} />
                    </div>
                </div>

                <div style={{ minHeight: "33vh", overflow: "hidden", position: "relative", padding: "2rem 0", background: "linear-gradient(90deg, rgba(123,31,162,0.05) 0%, rgba(25,118,210,0.05) 100%)" }}>
                    <h2 style={{ textAlign: "left", color: conveyrPurple, fontSize: "1.8rem", fontWeight: "bold", marginBottom: "1.5rem", padding: "0 2rem" }}>Conveyr - Digital Ecosystem in Images</h2>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", gap: "2rem", animation: "scroll 25s linear infinite", whiteSpace: "nowrap" }}>
                            <img src={require('../assets/ai-sm1.jpg')} alt="AI SM 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/aihc3.jpg')} alt="AI HC 3" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/Conveyr.png')} alt="Conveyr" style={{ height: "180px", width: "auto" }} />
                            <img src={require('../assets/ribbon/hypermarket.jpg')} alt="Urbangro" style={{ height: "180px", width: "auto" }} />
                            <img src={require('../assets/DS1.jpg')} alt="DS 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/DS2.jpg')} alt="DS 2" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/hc1.jpg')} alt="HC 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/hosp1.jpg')} alt="Hosp 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/hym1.jpg')} alt="HYM 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/hym4.jpg')} alt="HYM 4" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/sm1.jpg')} alt="SM 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/sm4.jpg')} alt="SM 4" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/ai-sm1.jpg')} alt="AI SM 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/aihc3.jpg')} alt="AI HC 3" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/Conveyr.png')} alt="Conveyr" style={{ height: "180px", width: "auto" }} />
                            <img src={require('../assets/ribbon/hypermarket.jpg')} alt="Urbangro" style={{ height: "180px", width: "auto" }} />
                            <img src={require('../assets/DS1.jpg')} alt="DS 1" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                            <img src={require('../assets/DS2.jpg')} alt="DS 2" style={{ height: "180px", width: "auto", borderRadius: "12px" }} />
                        </div>
                    </div>
                    <style>{`@keyframes scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); }}`}</style>
                </div>
                
                <div
                style={{
                    minHeight: "33vh",
                    position: "relative",
                    padding: "1.5rem 3rem",
                    display: "flex",
                    gap: "2rem",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
                >
                {/* LEFT COLUMN (STACKED TILES) */}
                <div style={{ flex: "1 1 68%", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                    
                    {/* 🔹 MIDDLE TILE */}
                    <div
                    onMouseEnter={() => setIsHoveredBottom(true)}
                    onMouseLeave={() => setIsHoveredBottom(false)}
                    style={{
                        color: isHoveredBottom ? "#fff" : homeRed,
                        fontWeight: 500,
                        fontSize: "0.75rem",
                        lineHeight: 1.58,
                        padding: "1.5rem 2rem",
                        transition: "all 0.35s ease",
                        background: isHoveredBottom ? homeRed : "transparent",
                        borderRadius: "18px",
                        cursor: "pointer",
                    }}
                    >
                    {middleTextContent}
                    </div>

                    {/* 🔹 BOTTOM TILE */}
                    <div
                    onMouseEnter={() => setIsHoveredBottom(true)}
                    onMouseLeave={() => setIsHoveredBottom(false)}
                    style={{
                        color: isHoveredBottom ? "#fff" : conveyrPurple,
                        fontWeight: 500,
                        fontSize: "0.75rem",
                        lineHeight: 1.58,
                        padding: "1.5rem 2rem 3.5rem 2rem",
                        transition: "all 0.35s ease",
                        background: isHoveredBottom ? conveyrPurple : "transparent",
                        borderRadius: "18px",
                        cursor: "pointer",
                        position: "relative",
                        maxHeight: "100%",
                        overflowY: "auto",
                    }}
                    >
                    <h1
                        style={{
                        fontSize: "2.5rem",
                        color: isHoveredBottom ? "#fff" : conveyrPurple,
                        fontWeight: "bold",
                        margin: "0 0 1rem 0",
                        transition: "color 0.35s ease",
                        }}
                    >
                        Conveyr
                    </h1>

                    {bottomTextContent}

                    <Link
                        to="/product"
                        style={{
                        position: "absolute",
                        bottom: "1.5rem",
                        right: "2rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: isHoveredBottom ? "#fff" : conveyrPurple,
                        textDecoration: "none",
                        fontSize: "1rem",
                        fontWeight: "bold",
                        transition: "color 0.35s ease",
                        }}
                    >
                        Product <span style={{ fontSize: "1.3rem" }}>→</span>
                    </Link>
                    </div>
                </div>

                {/* RIGHT COLUMN (STACKED LOGOS) */}
                <div
                style={{
                    flex: "0 0 28%",
                    display: "flex",
                    flexDirection: "column",   // 🔥 stack vertically
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "25rem",             // spacing between images
                    paddingTop: "3rem",
                }}
                >
                <img
                    src={require("../assets/ribbon/hypermarket.jpg")}
                    alt="Urbangro Logo"
                    style={{
                    width: "100%",
                    maxWidth: "480px",
                    height: "auto",
                    filter: "drop-shadow(0 4px 12px #bb093040)",
                    }}
                />

                <img
                    src={require("../assets/Conveyr.png")}
                    alt="Conveyr Logo"
                    style={{
                    width: "100%",
                    maxWidth: "180px",
                    height: "auto",
                    filter: "drop-shadow(0 4px 12px rgba(123, 31, 162, 0.25))",
                    }}
                />
                </div>

                </div>


                <div style={{ minHeight: "33vh", position: "relative", padding: "1.5rem 3rem", display: "flex", gap: "2rem", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div onMouseEnter={() => setIsHoveredBottom(true)} onMouseLeave={() => setIsHoveredBottom(false)} style={{ flex: "1 1 68%", color: isHoveredBottom ? "#fff" : conveyrPurple, fontWeight: 500, fontSize: "0.75rem", lineHeight: 1.58, padding: "1.5rem 2rem 3.5rem 2rem", transition: "all 0.35s ease", background: isHoveredBottom ? conveyrPurple : "transparent", borderRadius: "18px", cursor: "pointer", position: "relative", maxHeight: "100%", overflowY: "auto" }}>
                        <h1 style={{ fontSize: "2.5rem", color: isHoveredBottom ? "#fff" : conveyrPurple, fontWeight: "bold", margin: "0 0 1rem 0", transition: "color 0.35s ease" }}>Conveyr</h1>
                        {bottomTextContent}
                        <Link to="/
product" style={{ position: "absolute", bottom: "1.5rem", right: "2rem", display: "flex", alignItems: "center", gap: "0.5rem", color: isHoveredBottom ? "#fff" : conveyrPurple, textDecoration: "none", fontSize: "1rem", fontWeight: "bold", transition: "color 0.35s ease" }}>Product <span style={{ fontSize: "1.3rem" }}>→</span></Link>
                    </div>
                    <div style={{ flex: "0 0 28%", display: "flex", justifyContent: "center", alignItems: "flex-end", paddingTop: "3rem" }}>
                        <img src={require('../assets/Conveyr.png')} alt="Conveyr Logo" style={{ width: "100%", maxWidth: "180px", height: "auto", filter: "drop-shadow(0 4px 12px rgba(123, 31, 162, 0.25))" }} />
                    </div>
                </div>
            </div>

        <footer
        style={{
            padding: "2rem 1.5rem",
            textAlign: "center",
            background: "#fff",
            marginTop: "1rem",
            borderTop: "1px solid #e0e0e0",
        }}
        >
        {/* COMPANY */}
        <p style={{ margin: "0 0 0.6rem 0", fontWeight: 600 }}>
            © 2025 Algebracorp OPC Private Limited
        </p>

        {/* ADDRESS */}
        <p style={{ margin: "0 0 1.2rem 0", fontSize: "0.9rem", color: "#555" }}>
            Office Address: 16th Park View, Gaur Yamuna City Greater Noida. Up
        </p>

        {/* SOCIAL ICONS */}
        <div
            style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.4rem",
            marginBottom: "1rem",
            }}
        >
            {/* WhatsApp */}
            <a
            href="https://wa.me/+917518410292"
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
            style={{ display: "inline-flex" }}
            >
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                alt="WhatsApp"
                style={{
                height: "28px",
                width: "28px",
                transition: "transform 0.25s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            </a>

            {/* Instagram */}
            <a
            href="https://www.instagram.com/algebracorp"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
            style={{ display: "inline-flex" }}
            >
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                style={{
                height: "28px",
                width: "28px",
                transition: "transform 0.25s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            </a>
        </div>

        {/* TAGLINE */}
        <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
            Building India’s Next-Generation Digital & Commerce Ecosystems
        </p>
        </footer>
        </div>
    );
};

export default Home;